import { connect } from 'react-redux';
import Inventory from './inventory';

const mapStateToProps = (state) => {
  return {
    currentUser: state.session.user,

  };
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inventory);